import axios from 'axios';

const instance = axios.create();
instance.defaults.withCredentials = true;
instance.defaults.withXSRFToken = true;
export default instance;

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ToastService} from "./toast.service";
import { Router } from "@angular/router";
import {environment} from "../../environments/environment";
import { UserService } from "./user.service";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl: string;

  loggedIn = false;
  //token = '';
  token: string;
  failedReq : any;
  httpResponse : any;

  cancelToken: any;
  cancelSource: any;

  public static ola : any[];
  constructor(
    private http: HttpClient,
    public toastService: ToastService,
    private router: Router,
    private authService: AuthService
  ) {
    // this.apiUrl = environment.api.old_url;
    this.apiUrl = environment.api.baseUrl + '/';
  }

  // @ts-ignore
  doRequest(url, method, data,ignoreAuth = false, additionalHeaders = {}, apiUrl = null, multipart = false) {
    // this.apiUrl = apiUrl !== null ? apiUrl : environment.api.url;
    // this.apiUrl = 'https://stagingapi.salesommo.com/'

    this.apiUrl = environment.api.baseUrl + '/';

    let apiSrvc = this;
    let resp;

    //Serialize Params for GET Method
    if(method === 'GET' && data !== null) {
      if (url[url.length - 1] === '?') {
        let _get_params = this.setUrlParams(data);
        url = url + _get_params;
      } else {
        url = url + data;
      }
    }

    // Insert Token
    // let token = localStorage.getItem('token');

    this.authService.token().subscribe(token => {
      this.token = token;
    });

    const appLanguage = 'en';
    const Hoptions = {
      headers: {
        'Content-Type':  'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': appLanguage,
        'X-Client-UI': 'legacy',
      }
    };

    const HoptionsLogged = {
      headers: {
        'Content-Type':  'application/json',
        'Accept'  : 'application/json',
        'Accept-Language': appLanguage,
        'Authorization' : 'Bearer ' + this.token,
        'X-Client-UI': 'legacy',
      }
    };

    let finalHeaders = (this.token === null) ? Hoptions : HoptionsLogged;
    if(Object.keys(additionalHeaders).length > 0){
      finalHeaders = {
        headers: {...finalHeaders['headers'], ...additionalHeaders}
      }
    }

    if(multipart){
      finalHeaders.headers['Content-Type'] = 'multipart/form-data';
    }


    // Refresh Token
    instance.interceptors.response.use(
      // @ts-ignore
      response => response,
      // @ts-ignore
      error =>
      {
        if(error.response === undefined){
          return Promise.reject(error);
        }

        const initialReq = error.config;
        const {status} = error.response;

        return Promise.reject(error);
      }
    );

    switch (method) {
      case 'POST':
      case 'PATCH':
      case 'PUT':
        // @ts-ignore
        resp = instance[method.toLowerCase()](this.apiUrl + url,data, finalHeaders);
        break;
      case 'GET':
      case 'DELETE':
        // @ts-ignore
        resp =  instance[method.toLowerCase()](this.apiUrl + url, finalHeaders);
        break;
    }

    return resp;
  }

  /*
  async csrf(){
    return await instance.get(this.apiUrl + 'sanctum/csrf-cookie');
  }
  */

  async csrf() {
    try {
      const response = await instance.get(this.apiUrl + 'sanctum/csrf-cookie');
      // Verify the cookies were set
      console.log('CSRF request completed', document.cookie);
      return true;
    } catch (error) {
      console.error('CSRF request failed:', error);
      throw error;
    }
  }

  // @ts-ignore
  autocompleteResults(search, url) {
    let token = localStorage.getItem('token');

    if (this.cancelToken !== undefined) {
      this.cancelToken.cancel('Cancel previous request');
    }

    this.cancelToken = axios.CancelToken.source();

    const HoptionsLogged = {
      headers: {
        'Content-Type':  'application/json',
        'Accept'  : 'application/json',
        'Authorization' : 'Bearer ' + token,
      },
      cancelToken: this.cancelToken.token
    };

    return instance['post'](this.apiUrl + url, { type: 'pn', search }, HoptionsLogged);
  }

  // @ts-ignore
  setToken(token) { this.token = token; }
  // @ts-ignore
  setLogin(loggedIn) { this.loggedIn = loggedIn;}
  // @ts-ignore
  setUrlParams = function (params) {
    let _params = [];

    for (var prop in params) { _params.push(encodeURIComponent(prop) + '=' + encodeURIComponent(params[prop])); }
    return _params.join("&");
  };

  async refreshToken() {
    let apiSrvc = this;
    // Redo Login in Here
    const params = {
      username: localStorage.getItem('h_username'),
      password: localStorage.getItem('h_pwd'),
      grant_type : 'password'
    };

    let req =  this.doRequest("api/jwt/" , 'POST',params, true);
    return req;
  }

}
